import React from "react";

/**
 * Convert a long paragraph into clean bullet points on mobile.
 * Splits on periods/semicolons, removes very short fragments,
 * and renders as a tidy list.
 */
export function textToBullets(text) {
  if (!text || typeof text !== "string") return [];
  // Split on period+space, semicolons, or newlines
  const parts = text
    .replace(/\r/g, "")
    .split(/(?:\.\s+|;\s+|\n+)/)
    .map((s) => s.trim())
    .filter((s) => s.length > 12);  // drop tiny fragments
  return parts.map((s) => (s.endsWith(".") ? s : s + "."));
}

export default function BulletText({ text, max = 8, className = "" }) {
  const bullets = textToBullets(text).slice(0, max);
  if (!bullets.length) {
    return text ? <p className={className}>{text}</p> : null;
  }
  if (bullets.length === 1) {
    return <p className={className}>{bullets[0]}</p>;
  }
  return (
    <ul className={`space-y-2.5 ${className}`}>
      {bullets.map((b, i) => (
        <li key={i} className="flex items-start gap-2.5 min-w-0">
          <span className="text-heda-gold mt-2 flex-shrink-0 w-1 h-1 rounded-full bg-heda-gold" />
          <span className="flex-1 min-w-0 break-words">{b}</span>
        </li>
      ))}
    </ul>
  );
}
